import React from 'react'
import debounce from 'lodash/debounce'

import { useFeatureFlagContext } from './useFeatureFlagContext'
import { useLocalStorage } from '../useLocalStorage'

export const useScreenSizeHook = () => {
  const { getFeatureByKey, status } = useFeatureFlagContext()
  const isEnableDesktopLayout = getFeatureByKey('enableBelajarDesktopLayout')
  const [isDesktop, setIsDesktop] = React.useState<boolean>(false)
  const [, setDesktopScreenSizeFlag, , getScreenSizeFlagFromLocalStorage] =
    useLocalStorage('isDesktopScreenSize', false)

  const handleWindowSizeChange = debounce(() => {
    const isWindowDesktopWidth =
      window?.innerWidth >= 1024 && isEnableDesktopLayout

    setDesktopScreenSizeFlag(isWindowDesktopWidth)
    setIsDesktop(isWindowDesktopWidth)
  }, 500)

  React.useEffect(() => {
    if (status === 'success' && isEnableDesktopLayout !== isDesktop) {
      handleWindowSizeChange()
    }
    if (isEnableDesktopLayout) {
      window.addEventListener('resize', handleWindowSizeChange)
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange)
      }
    } else {
      setDesktopScreenSizeFlag(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status])

  return {
    isDesktop: getScreenSizeFlagFromLocalStorage() || isDesktop,
    status,
    toggleDesktop: isEnableDesktopLayout,
  }
}
